import React, { useState } from 'react';
import { endpoints } from '../api';
import { useNavigate } from 'react-router-dom';

const Register = () => {
    const [form, setForm] = useState({
        email: '',
        company_name: '',
        industry: '',
        password: '',
        confirm_password: ''
    });
    const navigate = useNavigate();

    const handleRegister = async (e) => {
        e.preventDefault();
        try {
            await endpoints.register(form);
            navigate('/login');
        } catch (err) {
            alert(err.response?.data?.error || "Registration failed");
        }
    };

    return (
        <div className="auth-container">
            <div className="auth-card">
                <h2>Create Account</h2>
                <p className="subtitle">Join TSP AI to automate your outreach</p>
                <form onSubmit={handleRegister}>
                    <div className="input-group">
                        <label>Email Address</label>
                        <input 
                            type="email" 
                            required 
                            placeholder="name@company.com"
                            onChange={e => setForm({...form, email: e.target.value})} 
                        />
                    </div>
                    <div className="input-group">
                        <label>Company Name</label>
                        <input 
                            type="text" 
                            required 
                            placeholder="Your Company"
                            onChange={e => setForm({...form, company_name: e.target.value})} 
                        />
                    </div>
                    <div className="input-group">
                        <label>Industry</label>
                        <input 
                            type="text" 
                            required 
                            placeholder="e.g. Fashion, Tech"
                            onChange={e => setForm({...form, industry: e.target.value})} 
                        />
                    </div>
                    <div className="input-group">
                        <label>Password</label>
                        <input 
                            type="password" 
                            required 
                            placeholder="••••••••"
                            onChange={e => setForm({...form, password: e.target.value})} 
                        />
                    </div>
                    <div className="input-group">
                        <label>Confirm Password</label>
                        <input 
                            type="password" 
                            required 
                            placeholder="••••••••"
                            onChange={e => setForm({...form, confirm_password: e.target.value})} 
                        />
                    </div>
                    <button type="submit" className="btn-primary">Register</button>
                </form>
                <p className="footer-link">
                    Already have an account? <span onClick={() => navigate('/login')}>Login</span>
                </p>
            </div>
        </div>
    );
};

export default Register;